import { css, type Theme } from "@emotion/react";
import type { ColorProfileTheme } from "aviary-tokens";
import { typography } from "aviary-tokens";

export const badgeBase = (theme: Theme) => css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.625rem;
  font-weight: ${typography.weightBold};
  color: ${theme.text.onBackground};
  border-radius: 50%;
`;

export const bordered = (theme: Theme) => css`
  border: 2px solid ${theme.system.textHover};
`;

export const inline = css`
  position: static;
  display: block;
`;

export const badgeSize = {
  small: css`
    width: 0.5rem;
    height: 0.5rem;
    top: -0.15rem;
    right: -0.15rem;
  `,
  medium: css`
    width: 0.75rem;
    height: 0.75rem;
    top: -0.25rem;
    right: -0.25rem;
  `,
  large: css`
    width: 1rem;
    height: 1rem;
    top: -0.3rem;
    right: -0.3rem;
  `,
};

export const countColors = (profile: ColorProfileTheme) => css`
  background-color: ${profile.backgroundBase};
`;

export const systemBadge = (theme: Theme) => css`
  background-color: ${theme.light.backgroundContrast};
  color: ${theme.text.onBackground};
`;

export const systemBadgeMuted = (theme: Theme) => css`
  background-color: ${theme.highlight.backgroundBase};
`;

export const lightBadge = (theme: Theme) => css`
  background-color: ${theme.light.backgroundBase};
  color: ${theme.light.textBase};
`;

export const textWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 1;
`;
